<template>
  <div class="item">
    <h2>
      <router-link
        v-if="isLink"
        :to="{ path: '/MyBookListDetail', query: { id: item.id } }"
        target="_blank"
        v-html="item.name"
      />
      <p v-else v-html="item.name" />
    </h2>
    <DetailLine title="学术标签" block show v-if="item.tag">
      <span v-for="(tag, idx) in getTags(item.tag)" :key="tag" class="tag">
        <span>{{ tag }}</span>
        <template v-if="showSemi(idx, item.tag)">;</template>
      </span>
    </DetailLine>
    <DetailLine v-if="isDetail" title="书单简介" :content="item.description" block />
    <DetailLine v-else title="书目数量" :content="item.bookCount" block red />
    <p>
      <DetailLine title="创建时间" :content="item.createTime" />
      <DetailLine title="更新时间" :content="item.updateTime" />
    </p>
    <div class="buttons">
      <slot name="buttons"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MyBookListItem',
  components: {},
  props: {
    isLink: {
      type: Boolean,
      default: true,
    },
    item: Object,
    isDetail: Boolean,
  },
  data() {
    return {}
  },
  computed: {},
  methods: {
    getTags(tags) {
      if (typeof tags === 'string') return tags.split(';')
      return tags
    },
    showSemi(index, tag) {
      const tags = this.getTags(tag)
      return index < tags.length - 1
    },
  },
  mounted() {},
}
</script>

<style lang="scss" scoped>
.item {
  h2 {
    margin-bottom: 10px;
    font-size: 18px;
    color: #333;
    a {
      color: #333;
      text-decoration: none;
    }
  }
  .tag {
    margin-right: 5px;
    span {
      color: $mainColor;
    }
  }
}
.buttons {
  margin-top: 20px;
}
</style>
